import classNames from "classnames";
import * as React from "react";
import { CSSProperties } from "react";
import { AuditContextProvider, Locations } from "~/common/audit";
import * as styles from "./EmptyList.less";
import { TimeLogsClock } from "./TimeLogsClock";

interface EmptyListProps {
    description: string;
    theme: keyof typeof EmptyListThemes;
    width?: number;
    wrapperClassName?: string;
}

export enum EmptyListThemes {
    activity_center = "activity_center",
    timelogs = "timelogs",
    project_plans = "project_plans",
    customers = "customers",
    users = "users",
    common = "common",
    approvals = "approvals",
    not_found = "not_found",
    dashboard = "dashboard",
    onboarding = "onboarding",
    only_text = "only_text",
    no_items = "no_items",
}

export const EmptyList: React.StatelessComponent<EmptyListProps> = ({
    children,
    description,
    theme,
    width,
    wrapperClassName,
}) => {
    let wrapperStyles: CSSProperties;
    if (width) {
        wrapperStyles = {
            width,
        };
    }

    const className = wrapperClassName ? classNames([styles.no_data, wrapperClassName]) : styles.no_data;
    return (
        <AuditContextProvider location={Locations.EmptyList}>
            <div className={className} style={wrapperStyles} role="status" aria-label="no data to show">
                <div className={styles.wrapper}>
                    {theme === "timelogs" ? <TimeLogsClock /> : <div className={styles[theme]} />}
                    <span className={styles.description}>{description}</span>
                    {children}
                </div>
            </div>
        </AuditContextProvider>
    );
};
